import React, { useEffect } from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import OrderStatus from "../component/User/Order/OrderStatus.jsx"
const OrderStatusPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
  <>
  <Header/>
  <OrderStatus/>

  <Footer/>
  </>
  )
}

export default OrderStatusPage